import loader from '../../assets/images/dots.svg';

const Loader = ({ message = '', width = '45', className } = {}) => (
  <div className={className}>
    <img src={loader} alt="" width={width} />
    {message.length > 0 && <h4 className="mt-4">{message}</h4>}
  </div>
);

export default Loader;
